import gql from 'graphql-tag'

export const Q_GET_ALL_TIMERECORDS = gql`query {
  timeRecords(order:"reverse:date") {
    id
     member {
      fullName
    }
    date
    clockIn
    lunchOut
    lunchIn
    clockOut
    modifiedBy
    memberId
    currentTeam
     subState
         state
         stateDuration
         fromMachine
         status
         remark
  }
}`
export const Q_GET_TIMERECORDS_WHERE = gql`query($where:ListWhere!) {
  timeRecords(where:$where,order:"reverse:date") {
    id
    date
    clockIn
    lunchOut
    lunchIn
    clockOut

    member {
    fullName
    mateId
    }
    shift {
       id
      name
      tooLateClockIn
    tooLateLunchIn
    lunchInTolerance
    clockInTolerance
       clockOutTolerance,
    lunchInTolerance
    isRestDay
    breakSkipped
    startMiss
    currentTeam
    clockIn
    clockOut

    }
    memberId
    modifiedBy
    currentTeam
         subState
         state
         stateDuration
         fromMachine
         status
         remark
         rejectRemark
  }
}`

export const Q_GET_MEMBER_TIMERECORDS = gql`query($where:ListWhere!) {
  timeRecords(where:$where,order:"reverse:date") {
    id
    date
     clockIn
    lunchOut
    lunchIn
    clockOut

    shift {
      tooLateClockIn
    tooLateLunchIn
    lunchInTolerance
    clockInTolerance
       clockOutTolerance,
    lunchInTolerance
    isRestDay
    breakSkipped
    startMiss
    currentTeam
    clockIn
    clockOut

    }

    member {
    id
    fullName
     schedules {
       id
       startDate
       endDate
       memberId
       weekDay
       scheduleType
       candidateShifts
       rotatingShifts
       shift {
        id
        name,
        isRestDay,
        breakSkipped,
        clockIn,
        clockOut,
      }
    }
    }
    memberId
   currentTeam
         subState
         state
         stateDuration
         fromMachine
         status
         remark
         rejectRemark
          modifiedBy
          approvedBy
          submittedBy
          rejectedBy
  }
}`

export const M_ADD_TIMERECORD = gql`mutation($date:Time!,$clockIn:Time,$clockOut:Time,$memberId:Int!,$lunchIn:Time,$lunchOut:Time,$currentTeam: String,
 $modifiedBy: String,
        $subState: String,
        $state: String,
        $stateDuration: Float,
        $fromMachine: Boolean,
        $status: String
             $remark: String
        ) {
  createTimeRecord(
    date:$date
    clockIn:$clockIn
    lunchIn:$lunchIn
    lunchOut:$lunchOut
    clockOut:$clockOut
    memberId:$memberId
    currentTeam:$currentTeam
    modifiedBy: $modifiedBy
        subState: $subState
        state:  $state
        stateDuration: $stateDuration
        fromMachine: $fromMachine
        status: $status
                 remark: $remark
  )
  {
    id
    memberId
    date
    clockIn
    clockOut
    lunchIn
    lunchOut
    currentTeam
    member {
      fullName
    }
  }
}`

export const M_UPDATE_TIMERECORD = gql`mutation($id:Int!,$date:Time,$clockIn:Time,$clockOut:Time,$lunchIn:Time,$lunchOut:Time,$ot:JSON
$modifiedBy: String,
        $subState: String,
        $state: String,
        $stateDuration: Float,
        $fromMachine: Boolean,
        $status: String
        $remark: String
        $logs: JSON
        $shiftId: Int
        ) {
  updateTimeRecord(id:$id
    date:$date
    clockIn:$clockIn
    lunchIn:$lunchIn
    lunchOut:$lunchOut
    clockOut:$clockOut
    modifiedBy:$modifiedBy
    logs:$logs
    ot: $ot
    shiftId: $shiftId
    subState: $subState
        state:  $state
        stateDuration: $stateDuration
        fromMachine: $fromMachine
        status: $status
        remark: $remark
    )
  {
    id
    date
    clockIn
    clockOut
    lunchIn
    lunchOut
    currentTeam
    modifiedBy
    member {
      fullName
    }
  }
}`
export const M_DELETE_TIMERECORDS = gql`mutation($where:ListWhere!) {
  deleteTimeRecord(where:$where)
}`

export const S_TIMERECORD_ADDED = gql`
  subscription {
  timeRecordAdded {
    id
    lunchIn
    lunchOut
    memberId
    member {
      fullName,
      firstName
    }
    date
    clockIn
    clockOut
    currentTeam
    modifiedBy
         subState
         state
         stateDuration
         fromMachine
         status
          remark
    overtimes {
      hrs
      overtimeTypeId
      type {
        name
      }
    }
  }
}`

export const M_UPSERT_TIMERECORDS = gql`
mutation($records:[TimeRecordInput]) {
upsertTimeRecords(records:$records) {
   id
       date
      clockIn
      clockOut
      lunchIn
      lunchOut
      memberId
      shiftId
      shift {
      id
      name
      tooLateClockIn
    tooLateLunchIn
    lunchInTolerance
    clockInTolerance
       clockOutTolerance,
    lunchInTolerance
    isRestDay
    breakSkipped
    startMiss
    currentTeam
    clockIn
    clockOut

    }
      ot
      logs
      modifiedBy
           subState
         state
         stateDuration
         fromMachine
         status
         remark
         rejectRemark
         approvedBy
         submittedBy
          rejectedBy
}
}
`

export const M_UPDATE_MANY_TIMERECORDS = gql`
mutation($records:[TimeRecordInput]) {
updateManyTimeRecords(records:$records) {
id
       date
      clockIn
      clockOut
      lunchIn
      lunchOut
      memberId
      shiftId
      shift {
      id
      name
      tooLateClockIn
    tooLateLunchIn
    lunchInTolerance
    clockInTolerance
       clockOutTolerance,
    lunchInTolerance
    isRestDay
    breakSkipped
    startMiss
    currentTeam
    clockIn
    clockOut

    }
      ot
      logs
      modifiedBy
           subState
         state
         stateDuration
         fromMachine
         status
         remark
         rejectRemark
         approvedBy
           rejectedBy
          submittedBy
 }
}
`

export const M_RESET_RECORDS = gql`
mutation($records: [ResetRecordInput!]!) {
  resetRecords(records: $records) {
    memberId
    date
    logsRequeued
    recordDeleted
  }
}
`
